// @ts-nocheck
import * as XLSX from 'xlsx';
import Pagination from '@components/Shared/Pagination/Pagination';
import { useState, useMemo, useRef, useEffect } from 'react';
import { FaSortUp, FaSortDown, FaChevronLeft, FaChevronRight, FaFileExcel, FaPrint } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import NoData from '@components/NoData/NoData';
import { ntxAPI } from '@API/axiosNeatex';
import NeatixModal from '@components/Modal/NeatixModal';

const ReportTable = ({
  RequestPrint,
  ReportName,
  data,
  columns,
  dataPerPage = 10,
  tableClass = '',
  theadClass = '',
  enableSearch = false,
  showRecordsSelector = false
}) => {
  const { t } = useTranslation();
  // إدارة الحالة للبحث
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [searchQuery, setSearchQuery] = useState('');
  const [recordsPerPage, setRecordsPerPage] = useState(dataPerPage); // حالة لإدارة عدد السجلات المعروضة
  const tableContainerRef = useRef(null);
  const [showScrollIcons, setShowScrollIcons] = useState(false);
  const [showLeftIcon, setShowLeftIcon] = useState(false);
  const [showRightIcon, setShowRightIcon] = useState(false);
  const isRTL = document.documentElement.dir === 'rtl' || localStorage.i18nextLng=== 'ar';

  useEffect(() => {
    const checkScrollable = () => {
      if (tableContainerRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = tableContainerRef.current;

        const adjustedScrollLeft = isRTL ? Math.abs(scrollLeft) : scrollLeft; // التعامل مع RTL

        setShowScrollIcons(scrollWidth > clientWidth); // هل يوجد تمرير؟

        // في RTL: إظهار أيقونة اليسار إذا لم يكن في النهاية
        setShowLeftIcon(isRTL ? adjustedScrollLeft < scrollWidth - clientWidth - 2 : scrollLeft > 0);

        // في RTL: إظهار أيقونة اليمين إذا لم يكن في البداية
        // setShowRightIcon(isRTL ? Math.floor(adjustedScrollLeft) > 0 : scrollLeft < scrollWidth - clientWidth);
        setShowRightIcon(isRTL ? Math.floor(adjustedScrollLeft) > 0 : scrollLeft < scrollWidth - clientWidth - 1);
      }
    };

    checkScrollable();
    window.addEventListener('resize', checkScrollable);

    tableContainerRef.current?.addEventListener('scroll', checkScrollable);

    return () => {
      window.removeEventListener('resize', checkScrollable);

      tableContainerRef.current?.removeEventListener('scroll', checkScrollable);
    };
  }, [data, columns, isRTL]);

  // دالة تحريك الجدول عند تمرير الماوس فوق الأيقونات

  const scrollTable = direction => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollBy({
        left: direction === 'left' ? -400 : 400,
        behavior: 'smooth'
      });
    }
  };

  const filteredData = useMemo(() => {
    if (!enableSearch || !searchQuery) return data;

    return data?.filter(row => {
      // إذا لم يتم تحديد أعمدة بحث، نبحث في جميع الأعمدة
      const columnsToSearch = columns.map(col => col.key);

      return columnsToSearch.some(columnKey => {
        const cellValue = row[columnKey] || '';
        return cellValue.toString().toLowerCase().includes(searchQuery.toLowerCase());
      });
    });
  }, [data, searchQuery, columns, enableSearch]);

  // فرز البيانات
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;
    return [...filteredData].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;

      if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortConfig]);

  // حساب الفهرس لبداية ونهاية البيانات
  const indexOfLastData = currentPage * recordsPerPage;
  const indexOfFirstData = indexOfLastData - recordsPerPage;
  const currentData = useMemo(
    () => sortedData?.slice(indexOfFirstData, indexOfLastData),
    [sortedData, indexOfFirstData, indexOfLastData]
  );

  // دالة التعامل مع الترتيب
  const handleSort = (columnKey, sortable = true) => {
    if (!sortable) return;
    setSortConfig(prevConfig => ({
      key: columnKey,
      direction: prevConfig.key === columnKey && prevConfig.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  // دالة التصدير
  const exportToExcel = () => {
    if (!sortedData || sortedData.length === 0) return;

    // تجهيز البيانات (تحويل الأعمدة بالعناوين بدل الـ keys)
    const exportData = sortedData.map(row => {
      const newRow = {};
      columns.forEach(col => {
        newRow[col.title] = row[col.key];
      });
      return newRow;
    });

    // إنشاء Sheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

    // حفظ الملف
    // XLSX.writeFile(workbook, 'report.xlsx');
    XLSX.writeFile(workbook, `${ReportName || 'report'}.xlsx`);
  };

  //#region    طباعة التقرير
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const handlePrint = async () => {
    setLoading(true);
    setError(null);
    setModalOpen(true);

    try {
      const response = await ntxAPI.post(
        'Reports/Print',
        {
          id: RequestPrint?.reportQuery?.reportId || null,
          parameterList:
            RequestPrint?.reportQuery?.parameterList?.map(item => ({
              id: item.id,
              value: item.value
            })) || []
        },
        {
          responseType: 'blob'
        }
      );
// debugger
      const blob = new Blob([response.data], {
        type: 'application/pdf'
      });

      const url = window.URL.createObjectURL(blob);
      setPdfUrl(url);
    } catch (err) {
      setError(t('حدث خطأ أثناء تحميل الملف.'));
      console.error('Error generating file:', err);
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  return (
    <>
      <div className='position-relative'>
        {/* أيقونات التمرير */}

        {showScrollIcons && (
          <div hidden={!showLeftIcon} className='scroll-icon left' onMouseEnter={() => scrollTable('left')}>
            <FaChevronLeft className='text-theme fw-bold' />
          </div>
        )}

        {showScrollIcons && (
          <div hidden={!showRightIcon} className='scroll-icon right' onMouseEnter={() => scrollTable('right')}>
            <FaChevronRight className='text-theme fw-bold' />
          </div>
        )}

        {(showRecordsSelector || enableSearch) && (
          <div className='d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3'>
            {showRecordsSelector && (
              <div className='flex-grow-1' style={{ minWidth: '200px', maxWidth: '250px' }}>
                <div className='input-group'>
                  <span className='input-group-text fw-bold'>{t('Display')}</span>
                  <select
                    className='form-select text-center'
                    value={recordsPerPage}
                    onChange={e => {
                      setRecordsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    {[10, 20, 30, 40].map(num => (
                      <option key={num} className='text-dark' value={num}>
                        {num}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className='d-flex gap-2 align-items-center'>
              {enableSearch && (
                <div className='flex-grow-1' style={{ minWidth: '400px', maxWidth: '400px' }}>
                  <div className='input-group'>
                    <span className='input-group-text fw-bold'>
                      <i className='fa fa-search text-theme me-2'></i>
                      {t('Search')}
                    </span>
                    <input
                      type='search'
                      autoComplete='off'
                      className='form-control'
                      placeholder={t('SearchPlaceholder')}
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
              )}
              <button
                className='btn btn-outline-theme'
                disabled={!sortedData || sortedData.length === 0}
                title={t('Export to Excel')}
                onClick={exportToExcel} // ✅ هنا الإضافة
              >
                <FaFileExcel />
              </button>
              <button
                className='btn btn-outline-theme'
                disabled={!sortedData || sortedData.length === 0}
                title={t('Print')}
                onClick={handlePrint}
              >
                <FaPrint />
              </button>
            </div>
          </div>
        )}

        {/* جدول البيانات */}
        <div className='table-responsive mb-3' ref={tableContainerRef}>
          <table className={tableClass || ' table table-hover'}>
            <thead className={theadClass || 'bg-theme bg-opacity-30'}>
              <tr>
                {columns?.map(column => (
                  <th
                    key={column.key}
                    onClick={() => handleSort(column.key, column.sortable)}
                    style={{
                      cursor: column.sortable === false ? 'default' : 'pointer',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {column.title}
                    <span style={{ display: 'inline-block', width: '1em' }}>
                      {sortConfig.key === column.key &&
                        column.sortable !== false &&
                        (sortConfig.direction === 'asc' ? (
                          <FaSortUp className='text-theme ms-2' />
                        ) : (
                          <FaSortDown className='text-theme ms-2' />
                        ))}
                    </span>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {currentData?.length === 0 ? (
                <tr>
                  <td colSpan={columns?.length} className='text-center'>
                    <NoData />
                  </td>
                </tr>
              ) : (
                currentData?.map((row, rowIndex) => {
                  return (
                    <tr key={rowIndex} className={row.rowClass}>
                      {columns?.map(column => (
                        <td key={column.key} className={'align-middle ' + (column.className || '')}>
                          <span>{row[column.key]}</span>
                        </td>
                      ))}
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          filteredData={sortedData}
          dataPerPage={recordsPerPage}
          handlePagination={setCurrentPage}
          currentPage={currentPage}
        />
      </div>

      <style>
        {`
   .scroll-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(var(--bs-theme-rgb), 0.2 );
  // background: rgba(0, 0, 0, 0.3);
  color: white;
  width: 40px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
 border-radius: 50px 0 0 50px; /* نصف دائرة على اليمين */
  cursor: pointer;
  transition: background 0.3s, opacity 0.3s;
  opacity: 0.6;
  z-index: 10;
}

.scroll-icon.left {
  left: 0;
  
   border-radius: 0 50px 50px 0; /* نصف دائرة على اليسار */
}

.scroll-icon.right {
  right: 0;
}

.scroll-icon:hover {
  background: rgba(var(--bs-theme-rgb), 0.3 ) ;
  opacity: 1;
}


    `}
      </style>

      <NeatixModal
        show={isModalOpen}
        setShow={setModalOpen}
        showHeader={false}
        centered
        bodyClassName='p-0'
        size={'xl'}
      >
        <div style={{ height: '90vh', paddingBottom: 3 }} className='border border-1 border-theme'>
          {loading && (
            <div className='d-flex justify-content-center align-items-center' style={{ height: 'calc(100% - 49px)' }}>
              <div className='spinner-grow text-theme' role='status'>
                <span className='visually-hidden'>{t('تحميل')}</span>
              </div>
            </div>
          )}

          {!loading && error && (
            <div
              className='d-flex justify-content-center align-items-center text-danger'
              style={{ height: 'calc(100% - 49px)' }}
            >
              <p>{error}</p>
            </div>
          )}

          {!loading && !error && pdfUrl && (
            <iframe
              src={pdfUrl}
              width='100%'
              height='100%'
              title='PDF Preview'
              style={{ height: 'calc(100% - 50px)', border: '1px solid #ccc' }}
            ></iframe>
          )}

          <div className='text-center'>
            <button
              className='btn btn-lg btn-theme w-25 rounded-0'
              onClick={() => {
                setModalOpen(false);
                setPdfUrl(null);
                setError(null);
              }}
            >
              {t('إلغاء')}
            </button>
          </div>
        </div>
      </NeatixModal>
    </>
  );
};

export default ReportTable;
